// Every amount the checkout shows goes through here, so the page never mixes
// "INR", "Rs" and "₹", or grouped and ungrouped figures. Amounts arrive both
// as numbers and as numeric strings from the API.
//
// ₹30,000 for whole amounts, ₹8,474.58 otherwise, Indian digit grouping, and
// the sign ahead of the symbol for a discount (-₹500).
export default function formatRupees(amount) {
  const value = Number(amount);
  if (amount === null || amount === undefined || amount === '' || Number.isNaN(value)) {
    return '—';
  }
  const rounded = Math.round(Math.abs(value) * 100) / 100;
  const digits = Number.isInteger(rounded) ? 0 : 2;
  const formatted = rounded.toLocaleString('en-IN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${value < 0 && rounded !== 0 ? '-' : ''}₹${formatted}`;
}
